import "./build.f3699847.js";


      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirede5b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirede5b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $ayMG0 = parcelRequire("ayMG0");
parcelRequire("acw62");

var $aRPiL = parcelRequire("aRPiL");

var $1njqU = parcelRequire("1njqU");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1q3Gg = parcelRequire("1q3Gg");

var $awWK6 = parcelRequire("awWK6");

var $2xlLX = parcelRequire("2xlLX");

var $fMFVx = parcelRequire("fMFVx");

var $ayMG0 = parcelRequire("ayMG0");

var $acw62 = parcelRequire("acw62");

var $1oUWq = parcelRequire("1oUWq");

var $1njqU = parcelRequire("1njqU");

var $eFaIB = parcelRequire("eFaIB");

const $682bd54691361f03$var$GAME_NAME = 'waterloo';
function $682bd54691361f03$export$2e2bcd8739ae039({ serverUrl: serverUrl, onJoinedMatch: onJoinedMatch }) {
    const { t: t } = (0, $1njqU.useTranslation)();
    const [playerName, setPlayerName] = (0, $acw62.useState)(()=>localStorage.getItem('waterloo-name') || '');
    const [view, setView] = (0, $acw62.useState)('name-entry');
    const [numPlayers, setNumPlayers] = (0, $acw62.useState)(2);
    const [matchID, setMatchID] = (0, $acw62.useState)('');
    const [joinCode, setJoinCode] = (0, $acw62.useState)('');
    const [playerID, setPlayerID] = (0, $acw62.useState)(null);
    const [credentials, setCredentials] = (0, $acw62.useState)(null);
    const [players, setPlayers] = (0, $acw62.useState)([]);
    const [error, setError] = (0, $acw62.useState)(null);
    const [isLoading, setIsLoading] = (0, $acw62.useState)(false);
    const [copied, setCopied] = (0, $acw62.useState)(null);
    const lobbyClient = new (0, $1oUWq.L)({
        server: serverUrl
    });
    const saveName = ()=>{
        if (playerName.trim()) {
            localStorage.setItem('waterloo-name', playerName.trim());
            setView('menu');
        }
    };
    const createMatch = async ()=>{
        setIsLoading(true);
        setError(null);
        try {
            const { matchID: newMatchID } = await lobbyClient.createMatch($682bd54691361f03$var$GAME_NAME, {
                numPlayers: numPlayers
            });
            const { playerID: newPlayerID, playerCredentials: playerCredentials } = await lobbyClient.joinMatch($682bd54691361f03$var$GAME_NAME, newMatchID, {
                playerName: playerName.trim()
            });
            setMatchID(newMatchID);
            setPlayerID(newPlayerID);
            setCredentials(playerCredentials);
            setView('waiting');
        } catch (err) {
            setError(t('error.createFailed', {
                message: err.message
            }));
        } finally{
            setIsLoading(false);
        }
    };
    const joinMatch = async ()=>{
        if (!joinCode.trim()) {
            setError(t('error.enterMatchCode'));
            return;
        }
        setIsLoading(true);
        setError(null);
        try {
            const match = await lobbyClient.getMatch($682bd54691361f03$var$GAME_NAME, joinCode.trim());
            const availableSlot = match.players.find((p)=>!p.name);
            if (!availableSlot) {
                setError(t('error.matchFull'));
                return;
            }
            const { playerID: newPlayerID, playerCredentials: playerCredentials } = await lobbyClient.joinMatch($682bd54691361f03$var$GAME_NAME, joinCode.trim(), {
                playerName: playerName.trim()
            });
            setMatchID(joinCode.trim());
            setPlayerID(newPlayerID);
            setCredentials(playerCredentials);
            setNumPlayers(match.players.length);
            setView('waiting');
        } catch (err) {
            setError(t('error.joinFailed', {
                message: err.message
            }));
        } finally{
            setIsLoading(false);
        }
    };
    // Poll for player updates in waiting room
    (0, $acw62.useEffect)(()=>{
        if (view !== 'waiting' || !matchID) return;
        const pollPlayers = async ()=>{
            try {
                const match = await lobbyClient.getMatch($682bd54691361f03$var$GAME_NAME, matchID);
                setPlayers(match.players);
                // Check if all players have joined
                const allJoined = match.players.every((p)=>p.name);
                if (allJoined) {
                    // Build playerNames map from match data
                    const playerNames = {};
                    match.players.forEach((p, i)=>{
                        playerNames[String(i)] = p.name || `Player ${i}`;
                    });
                    onJoinedMatch({
                        matchID: matchID,
                        playerID: playerID,
                        credentials: credentials,
                        numPlayers: match.players.length,
                        playerNames: playerNames
                    });
                }
            } catch (err) {
                console.error('Failed to poll match:', err);
            }
        };
        pollPlayers();
        const interval = setInterval(pollPlayers, 2000);
        return ()=>clearInterval(interval);
    }, [
        view,
        matchID,
        playerID,
        credentials,
        onJoinedMatch
    ]);
    const copyMatchCode = (0, $acw62.useCallback)(()=>{
        navigator.clipboard.writeText(matchID);
        setCopied('code');
        setTimeout(()=>setCopied(null), 1500);
    }, [
        matchID
    ]);
    const copyMatchLink = (0, $acw62.useCallback)(()=>{
        const url = `${window.location.origin}/online.html?match=${matchID}`;
        navigator.clipboard.writeText(url);
        setCopied('link');
        setTimeout(()=>setCopied(null), 1500);
    }, [
        matchID
    ]);
    // Check for match code in URL on mount
    (0, $acw62.useEffect)(()=>{
        const params = new URLSearchParams(window.location.search);
        const matchParam = params.get('match');
        if (matchParam) {
            setJoinCode(matchParam);
            if (playerName.trim()) setView('join');
        }
    }, []);
    if (view === 'name-entry') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lobby",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lobby-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('lobby.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        children: t('lobby.enterName')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        value: playerName,
                        onChange: (e)=>setPlayerName(e.target.value),
                        placeholder: t('lobby.yourName'),
                        maxLength: 20,
                        onKeyDown: (e)=>e.key === 'Enter' && saveName(),
                        autoFocus: true
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        onClick: saveName,
                        disabled: !playerName.trim(),
                        children: t('button.continue')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFaIB.default), {})
        ]
    });
    if (view === 'menu') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lobby",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lobby-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('lobby.title')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "welcome",
                        children: t('lobby.welcome', {
                            name: playerName
                        })
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "menu-buttons",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setView('create'),
                                children: t('lobby.createMatch')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: ()=>setView('join'),
                                children: t('lobby.joinMatch')
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                        className: "change-name",
                        onClick: ()=>setView('name-entry'),
                        children: t('button.changeName')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFaIB.default), {})
        ]
    });
    if (view === 'create') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lobby",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lobby-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('lobby.createMatch')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("label", {
                        children: [
                            t('lobby.numPlayers'),
                            /*#__PURE__*/ (0, $ayMG0.jsxs)("select", {
                                value: numPlayers,
                                onChange: (e)=>setNumPlayers(Number(e.target.value)),
                                children: [
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 2,
                                        children: t('lobby.players2')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 3,
                                        children: t('lobby.players3')
                                    }),
                                    /*#__PURE__*/ (0, $ayMG0.jsx)("option", {
                                        value: 4,
                                        children: t('lobby.players4')
                                    })
                                ]
                            })
                        ]
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "error",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "button-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "secondary",
                                onClick: ()=>setView('menu'),
                                children: t('button.back')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: createMatch,
                                disabled: isLoading,
                                children: isLoading ? t('button.creating') : t('button.create')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFaIB.default), {})
        ]
    });
    if (view === 'join') return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
        className: "lobby",
        children: [
            /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                className: "lobby-card",
                children: [
                    /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                        children: t('lobby.joinMatch')
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsx)("input", {
                        type: "text",
                        value: joinCode,
                        onChange: (e)=>setJoinCode(e.target.value),
                        placeholder: t('lobby.matchCode'),
                        onKeyDown: (e)=>e.key === 'Enter' && joinMatch(),
                        autoFocus: true
                    }),
                    error && /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                        className: "error",
                        children: error
                    }),
                    /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                        className: "button-row",
                        children: [
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                className: "secondary",
                                onClick: ()=>setView('menu'),
                                children: t('button.back')
                            }),
                            /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                onClick: joinMatch,
                                disabled: isLoading || !joinCode.trim(),
                                children: isLoading ? t('button.joining') : t('button.join')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFaIB.default), {})
        ]
    });
    if (view === 'waiting') {
        const joinedCount = players.filter((p)=>p.name).length;
        const totalSlots = players.length;
        return /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
            className: "lobby",
            children: [
                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                    className: "lobby-card waiting-room",
                    children: [
                        /*#__PURE__*/ (0, $ayMG0.jsx)("h1", {
                            children: t('lobby.waitingRoom')
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "match-code",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                    children: t('lobby.matchCodeLabel')
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsx)("code", {
                                    children: matchID
                                }),
                                /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                    className: "copy-buttons",
                                    children: [
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "small",
                                            onClick: copyMatchCode,
                                            children: copied === 'code' ? t('button.copied') : t('button.copyCode')
                                        }),
                                        /*#__PURE__*/ (0, $ayMG0.jsx)("button", {
                                            className: "small",
                                            onClick: copyMatchLink,
                                            children: copied === 'link' ? t('button.copied') : t('button.copyLink')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                            className: "players-list",
                            children: [
                                /*#__PURE__*/ (0, $ayMG0.jsx)("h3", {
                                    children: t('lobby.playersCount', {
                                        joined: joinedCount,
                                        total: totalSlots
                                    })
                                }),
                                players.map((player, idx)=>/*#__PURE__*/ (0, $ayMG0.jsxs)("div", {
                                        className: `player-slot ${player.name ? 'filled' : 'empty'}`,
                                        children: [
                                            /*#__PURE__*/ (0, $ayMG0.jsx)("span", {
                                                className: "player-number",
                                                children: t('lobby.playerSlot', {
                                                    number: idx + 1
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $ayMG0.jsxs)("span", {
                                                className: "player-name",
                                                children: [
                                                    player.name || t('lobby.waiting'),
                                                    player.id === Number(playerID) && ` ${t('lobby.you')}`
                                                ]
                                            })
                                        ]
                                    }, idx))
                            ]
                        }),
                        /*#__PURE__*/ (0, $ayMG0.jsx)("p", {
                            className: "waiting-hint",
                            children: t('lobby.autoStart')
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $ayMG0.jsx)((0, $eFaIB.default), {})
            ]
        });
    }
    return null;
}


// Determine server URL - same origin in production, localhost:8000 in dev
const $03e8fcd41b458ed4$var$SERVER_URL = window.location.port === '3000' ? 'http://localhost:8000' : window.location.origin;
function $03e8fcd41b458ed4$export$2e2bcd8739ae039() {
    const [gameState, setGameState] = (0, $acw62.useState)(null);
    if (!gameState) return /*#__PURE__*/ (0, $ayMG0.jsx)((0, $682bd54691361f03$export$2e2bcd8739ae039), {
        serverUrl: $03e8fcd41b458ed4$var$SERVER_URL,
        onJoinedMatch: setGameState
    });
    const WaterlooClient = (0, $1q3Gg.Client)({
        game: (0, $2xlLX.default),
        board: (0, $fMFVx.default),
        numPlayers: gameState.numPlayers,
        multiplayer: (0, $awWK6.S)({
            server: $03e8fcd41b458ed4$var$SERVER_URL
        }),
        debug: false
    });
    return /*#__PURE__*/ (0, $ayMG0.jsx)("div", {
        className: "app-container",
        children: /*#__PURE__*/ (0, $ayMG0.jsx)(WaterlooClient, {
            matchID: gameState.matchID,
            playerID: gameState.playerID,
            credentials: gameState.credentials,
            serverUrl: $03e8fcd41b458ed4$var$SERVER_URL,
            onJoinNewMatch: setGameState,
            playerNames: gameState.playerNames
        })
    });
}


const $fd7291004ca98d44$var$container = document.getElementById('root');
const $fd7291004ca98d44$var$root = (0, $aRPiL.createRoot)($fd7291004ca98d44$var$container);
$fd7291004ca98d44$var$root.render(/*#__PURE__*/ (0, $ayMG0.jsx)((0, $1njqU.I18nProvider), {
    children: /*#__PURE__*/ (0, $ayMG0.jsx)((0, $03e8fcd41b458ed4$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=online.c6267335.js.map
